<template>
  <v-card>
    <v-card-title class="headline">
      Mettre à jour la visibilité des semestres
    </v-card-title>
    <v-card-text>
      <div class="mb-4">
        Sélectionnez les semestres que vous souhaitez rendre visibles :
      </div>
      <v-checkbox
        v-model="selectedSemesters"
        label="Semestre 1"
        value="S1"
        hide-details
        class="mt-2"
      ></v-checkbox>
      <v-checkbox
        v-model="selectedSemesters"
        label="Semestre 2"
        value="S2"
        hide-details
        class="mt-2"
      ></v-checkbox>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="close">Annuler</v-btn>
      <v-btn
        color="primary"
        @click="updateVisibility"
        :disabled="selectedSemesters.length === 0"
      >
        Mettre à jour
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DialogUpdateVisibility",
  data() {
    return {
      selectedSemesters: ["S1", "S2"],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    updateVisibility() {
      this.$store
        .dispatch("materials/updateVisibilityBySemester", {
          semesters: this.selectedSemesters,
        })
        .then(() => {
          this.close();
        })
        .catch(() => {});
    },
  },
};
</script>
